import { useState } from "react"
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { sellPhone } from "../../api/products/post"

type Props = {
    currentStore: any
    phone: any | null
    onClose: () => void
    onSell: (updatedPhone: any) => void
}

export default function SellPhoneModal({ currentStore, phone, onClose, onSell }: Props) {
    const [clientName, setClientName] = useState("")
    const [clientPhone, setClientPhone] = useState("")
    const [sellPrice, setSellPrice] = useState("")
    const [paid, setPaid] = useState("")
    const [error, setError] = useState("")

    if (!phone) return null

    const handleSell = async () => {
        try {
            let res = await sellPhone(phone._id, {
                storeId: currentStore?._id,
                sellPrice,
                paid,
                clientName,
                clientPhone,
            })

            onSell(res)
            onClose()
        } catch (e: any) {
            setError(e.response?.data?.message || "Erreur lors de la vente")
        }
    }

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <motion.div
                    className="bg-white rounded-2xl ml-52 w-full max-w-md p-6 space-y-6"
                    initial={{ scale: 0.9, y: 40 }}
                    animate={{ scale: 1, y: 0 }}
                    exit={{ scale: 0.9, y: 40 }}
                >
                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold">
                            Vendre téléphone
                        </h2>
                        <button onClick={onClose}>
                            <X />
                        </button>
                    </div>

                    {/* Téléphone */}
                    <div className="bg-gray-50 rounded-xl p-3 text-sm">
                        <p className="font-medium">{phone.modelId.name}</p>
                        <p className="text-gray-500">IMEI : {phone.imei}</p>
                    </div>

                    {error && (
                        <div className="bg-red-50 text-red-600 text-sm p-2 rounded-lg">
                            {error}
                        </div>
                    )}

                    {/* Form */}
                    <div className="space-y-4">

                        <div>
                            <label className="text-sm text-gray-600">
                                Nom du client *
                            </label>
                            <input
                                value={clientName}
                                onChange={(e) => setClientName(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">
                                Téléphone du client
                            </label>
                            <input
                                value={clientPhone}
                                onChange={(e) => setClientPhone(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">
                                Prix de vente (FCFA) *
                            </label>
                            <input
                                type="number"
                                value={sellPrice}
                                onChange={(e) => setSellPrice(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">
                                Montant payé (FCFA) *
                            </label>
                            <input
                                type="number"
                                value={paid}
                                onChange={(e) => setPaid(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2"
                            />
                        </div>

                        {/* Calcul dette */}
                        {sellPrice && paid && (
                            <div className="text-sm text-gray-600">
                                Reste à payer :{" "}
                                <span className="font-semibold text-red-600">
                                    {(Number(sellPrice) - Number(paid)).toLocaleString()} FCFA
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Actions */}
                    <div className="flex justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-xl border"
                        >
                            Annuler
                        </button>
                        <button
                            onClick={handleSell}
                            className="px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700"
                        >
                            Valider la vente
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    )
}
